<template>
  <div class="call-fb-card-count-item-container">
    <span class="label">
      {{ label }}
    </span>
    <BTooltip
      top
      :disabled="rating !== 'none'"
    >
      <template #content>
        <span>{{ $t('training.callFb.processing', { label }) }}</span>
      </template>
      <div class="count-item-content">
        <div
          class="value"
          :class="`rating-${rating}`"
        >
          {{ value === null ? $t('general.none') : value }}
        </div>
        <CallFbPercentageBar
          :percentage="percentage"
          :rating="rating"
        />
        <div class="max-value">
          {{ maxValue }}
        </div>
      </div>
    </BTooltip>
  </div>
</template>

<script lang="ts" setup>
import BTooltip from '@/plugins/biscuet-materials/components/atoms/BTooltip.vue';
import CallFbPercentageBar from './CallFbPercentageBar.vue';
import type { TRating } from './types';

type TProps = {
  label: string;
  value: number;
  percentage: number;
  rating: TRating;
  maxValue: number;
};

defineProps<TProps>();
</script>

<style lang="scss" scoped>
.call-fb-card-count-item-container {
  display: flex;
  flex-direction: column;
  gap: $basespace-50;
}

.count-item-content {
  display: flex;
  flex-direction: column;
  gap: $basespace-50;
}

.label {
  color: $textcolor-light;
  padding-bottom: $basespace-50;
}
.value {
  font-size: $fontsize-300;
  font-weight: 700;
}
.max-value {
  color: $textcolor-light;
  font-size: $fontsize-100;
  font-weight: 400;
  text-align: right;
}

.rating-fail {
  color: $basecolor-error;
}
.rating-passable {
  color: $basecolor-secondary;
}
.rating-good {
  color: $basecolor-success;
}
.rating-none {
  color: $textcolor-light;
}
</style>
